import { render, staticRenderFns } from "./NovaChip.vue?vue&type=template&id=790c94b0&scoped=true&lang=pug&"
import script from "./NovaChip.vue?vue&type=script&lang=js&"
export * from "./NovaChip.vue?vue&type=script&lang=js&"
import style0 from "./NovaChip.vue?vue&type=style&index=0&id=790c94b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790c94b0",
  null
  
)

export default component.exports